import { rgba } from 'polished';
const brand = {
    beige: '#F4F3EE',
    beigeDark: '#E9E7DD',
    black: '#000000',
    green: '#9DAD98',
    greenBright: '#889E83',
    greyLight: '#F4F3EE',
    greyMid: '#BEBEBE',
    greyDark: '#2B2E34',
    pink: '#FF8C93',
    white: '#ffffff',
    validation: {
        invalid: '#DA291C',
        valid: '#008C15',
    },
};
export default brand;
export const textShadow = `drop-shadow(0px 0px 6px ${rgba(brand.greyDark, 0.5)})`;
